import { concat } from 'lodash'

import { AppContainer } from '@dlm/common'
import '@enterprise-ui/canvas-ui-css'
import '@dlm/common/dist/esm/css/styles.css'

import './stylesheets/customStyles.scss'
import './stylesheets/style.scss'
import apiConfig from './config/apiConfig'
import navigationConfig from './config/navigationConfig'

function App() {
  return (
    <AppContainer
      appName="Carrier Onboarding"
      authConfig={apiConfig.auth}
      baseADGroups={concat(
        apiConfig.auth.requiredPermissions.admin,
        apiConfig.auth.requiredPermissions.user,
        apiConfig.auth.requiredPermissions.carrier,
      )}
      navigationConfig={navigationConfig}
    />
  )
}

export default App
